<template>
    <div class="actions__add-filter__wrapper">
        <div class="actions__add-filter__button">
            <button @click="showFilter = 'list'" key="on" v-if="showFilter == ''" class="top-button">Add Filter</button>
            <button @click="showFilter = ''" key="off" v-if="showFilter != ''" class="closed"><inline-svg src="/images/close.svg" class="main-table__header-item__icon" aria-label="Settings"></inline-svg></button>
            <transition-group name="dropdown">
                <div class="filters-list" v-show="showFilter == 'list'" key="list">
                    <template v-if="isLoadingFilter">
                        <div class="loader my-5 mx-auto">
                            <svg class="circular" viewBox="25 25 50 50">
                                <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="3" stroke-miterlimit="10"/>
                            </svg>
                        </div>
                    </template>
                    <template v-else>
                        <template v-for="(value, index) in filtersInit">
                            <div class="filters-list__item" @click.stop="showFilter = index">{{ value[0] }}</div>
                        </template>
                    </template>
                </div>
                <template v-for="(value_is, index_is) in filtersInit">
                    <div class="filter-form" v-show="showFilter == index_is" :key=index_is>
                        <div class="filter-form__header">{{ value_is[0] }}</div>
                        <template v-if="value_is[1] == 'string'">
                            <div class="input-group">
                                <label class="typo__label">Choose {{ value_is[0] }}:</label>
                                <multiselect v-model="filterValue[index_is]" :options="value_is[2]" :multiple="true" :clear-on-select="false" :close-on-select="false" :preserve-search="true" placeholder="Pick some" :preselect-first="false" selectLabel="+" selectedLabel="✓" deselectLabel="x" openDirection="bottom">
                                    <template slot="selection" slot-scope="{ values, search, isOpen }"><template v-if="filterValue[index_is] && !isOpen"><span class="multiselect__single" v-if="filterValue[index_is].length">{{ values.length }} options selected</span></template></template>
                                </multiselect>
                                <button @click.stop="reloadFilter()" class="filter-form__apply">Apply</button>
                            </div>
                        </template>
                        <template v-else-if="value_is[1] == 'boolean'">
                            <div class="input-group">
                                <label class="typo__label" style="width: 100%">Choose {{ value_is[0] }}:</label>
                                <input type="radio" v-bind:id="value_is[0] + 'one'" value="true" :name="value_is[0]" v-model="filterValue[index_is]">
                                <label class="radio-label" v-bind:for="value_is[0] + 'one'">{{ customLabels && customLabels[index_is] && customLabels[index_is]['true'] ? customLabels[index_is]['true'] : 'Yes' }}</label>
                                <input type="radio" v-bind:id="value_is[0] + 'two'" value="false" :name="value_is[0]" v-model="filterValue[index_is]">
                                <label class="radio-label" v-bind:for="value_is[0] + 'two'">{{ customLabels && customLabels[index_is] && customLabels[index_is]['false'] ? customLabels[index_is]['false'] : 'No' }}</label>
                                <button @click.stop="reloadFilter()" class="filter-form__apply">Apply</button>
                            </div>
                        </template>
                        <template v-else-if="value_is[1] == 'datetime'">
                            <div class="input-group">
                                <label class="typo__label">From {{ value_is[0] }}:</label>
                                <vue-date-picker :disabled-date="(date) => date >= disabledAfter" @change="timezone(index_is + '_from')" v-model="filterValue[index_is+ '_from']" format="DD/MM/YYYY"></vue-date-picker>
                                <label class="typo__label">To {{ value_is[0] }}:</label>
                                <vue-date-picker :disabled-date="(date) => date >= disabledAfter" @change="timezone(index_is + '_to')" v-model="filterValue[index_is+ '_to']" format="DD/MM/YYYY"></vue-date-picker>
                                <button @click.stop="reloadFilter()" class="filter-form__apply">Apply</button>
                            </div>
                        </template>
                        <template v-else>
                            <div class="input-group">
                                <label class="typo__label">Min {{ value_is[0] }}:</label>
                                <input v-model.number="filterValue[index_is + '_min']" v-bind:min="0" v-bind:max="value_is[2]" type="number">
                                <label class="typo__label">Max {{ value_is[0] }}:</label>
                                <input v-model.number="filterValue[index_is + '_max']" v-bind:min="0" v-bind:max="value_is[2]" type="number">
                                <button @click.stop="reloadFilter()" class="filter-form__apply">Apply</button>
                            </div>
                        </template>
                    </div>
                </template>
            </transition-group>
        </div>
        <div class="account__table__tags">
            <template v-for="(value_is2, index_is2) in filterTags">
                <template v-if="Number.isInteger(value_is2)">
                    <div v-if="Number.isInteger(value_is2)" class="account__table__tags-tag" @click.stop="showFilter = index_is2.substr(0, index_is2.length-4)">
                        {{filtersInit[index_is2.substr(0, index_is2.length-4)][0]+' '+(index_is2.split('_').pop() === 'min' ? '>=' : '<=')}} {{ value_is2 }} <i @click.stop="removeFilter(index_is2, value_is2, 'number')" aria-hidden="true" tabindex="1" class="multiselect__tag-icon"></i>
                    </div>
                </template>
                <template v-else-if="value_is2 == 'true' || value_is2 == 'false'">
                    <div class="account__table__tags-tag" @click.stop="showFilter = index_is2">
                        {{filtersInit[index_is2][0]}}: {{ customLabels && customLabels[index_is2] && customLabels[index_is2][value_is2] ? customLabels[index_is2][value_is2] : value_is2 == 'true' ? 'Yes' : 'No'}} <i @click.stop="removeFilter(index_is2, value_is2, 'boolean')" aria-hidden="true" tabindex="1" class="multiselect__tag-icon"></i>
                    </div>
                </template>
                <template v-else-if="(typeof value_is2 === 'string' || value_is2 instanceof String) && value_is2.length > 0">
                    <div class="account__table__tags-tag" @click.stop="showFilter = index_is2">
                        {{filtersInit[index_is2][0]}}: {{ value_is2 }} <i @click.stop="removeFilter(index_is2.replace('string_',''), value_is2, 'date')" aria-hidden="true" tabindex="1" class="multiselect__tag-icon"></i>
                    </div>
                </template>
                <template v-else-if="value_is2.length > 0">
                    <template v-for="string in value_is2">
                        <div class="account__table__tags-tag" @click.stop="showFilter = index_is2">
                            {{filtersInit[index_is2][0]}}: {{ string }} <i @click.stop="removeFilter(index_is2, string, 'string')" aria-hidden="true" tabindex="1" class="multiselect__tag-icon"></i>
                        </div>
                    </template>
                </template>
            </template>
        </div>
    </div>
</template>


<script>

import {Multiselect} from 'vue-multiselect';

export default {
    name: 'data-filter',
    props : {
        filtersInit: Object,
        customLabels: {},
        isLoadingFilter: false,
        valuesInit: {
            type: Object,
            required: false
        },
    },
    components: {
        Multiselect,
    },
    data: function () {
        return {
            showFilter: "",
            filterValue: this.valuesInit ?? {},
            filterTags: {},
            disabledAfter: this.$moment(moment().add(1, 'day').format("DD-MM-YYYY"), "DD-MM-YYYY"),
        }
    },
    methods: {
        removeFilter(index_is, value_is, number_is = 'string') {
            if (number_is == 'number') {
                this.filterValue[index_is] = '';
            } else if (number_is == 'boolean') {
                this.filterValue[index_is] = '';
            } else if (number_is == 'date') {
                this.filterValue[index_is] = '';
                this.filterValue['string_' + index_is] = '';
            }
            else {
                this.filterValue[index_is].splice(this.filterValue[index_is].indexOf(value_is), 1);
            }
            this.reloadFilter();
        },
        reloadFilter(isDefaultValues = false) {
            const showed = this.showFilter;
            this.showFilter = ''; //reactive trick width object

            if (!showed) this.showFilter = '';

            this.filterTags = Object.assign({}, this.filterValue);

            if(!isDefaultValues){
                this.$emit('filterApply', {
                    filter_data: this.filterValue
                });
            }
        },
        timezone($input) {
            this.filterValue['string_' + $input] = moment(this.filterValue[$input]).format('DD-MM-YYYY');
        }
    },
    watch: {
        filtersInit: function() {
            for (var prop in this.filtersInit) {
                if (this.filtersInit[prop][1] == 'number') {
                    this.filterValue[prop + '_min'] = '';
                    this.filterValue[prop + '_max'] = '';
                }
            }
            this.reloadFilter(true);
        }
    }
}
</script>

<!-- plugin-styles -->
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
